export { default } from './Asterisk';
